import { CurrencyEnum } from '../../lib/types/enums/common/currency.enum'
import { TravelExpensesSalaryStaffsFilters } from '../../lib/types/models/travel-expenses/travel-expenses-staff'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getStaffExpensesSalaries(
  filter?: TravelExpensesSalaryStaffsFilters,
  search?: string
) {
  return restApiClient
    .url(
      encodeNestedObject(API.travelExpenses.getTravelExpensesSalaryStaffs.url, {
        filter,
        search,
        totalSalary: true
      })
    )
    .get<{ totals: { currency: CurrencyEnum; total: number }[] }>()
}
